import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import getRecommendPremiumToStandardUrlQueryParameters from './src/ui/__generated__/RecommendPremiumToStandardModalRendererQuery$parameters';
import type { RecommendPremiumToStandardModalRendererQuery$variables } from './src/ui/__generated__/RecommendPremiumToStandardModalRendererQuery.graphql';

type EntryPointParams = RecommendPremiumToStandardModalRendererQuery$variables;
export const recommendPremiumToStandardModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(async () =>
		import(
			/* webpackChunkName: "async-recommend-premium-to-standard-modal" */ './src/ui/RecommendPremiumToStandardModalRenderer.tsx'
		).then(
			({ RecommendPremiumToStandardModalRenderer }) => RecommendPremiumToStandardModalRenderer,
		),
	),
	getPreloadProps: ({ cloudIds }: EntryPointParams) => ({
		queries: {
			getRecommendPremiumToStandardUrlQuery: {
				parameters: getRecommendPremiumToStandardUrlQueryParameters,
				variables: {
					cloudIds,
				},
			},
		},
	}),
});
